import { render, staticRenderFns } from "./SignatureHistory.vue?vue&type=template&id=389af2b1&scoped=true"
import script from "./SignatureHistory.vue?vue&type=script&lang=js"
export * from "./SignatureHistory.vue?vue&type=script&lang=js"
import style0 from "./SignatureHistory.vue?vue&type=style&index=0&id=389af2b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389af2b1",
  null
  
)

export default component.exports